import { render, staticRenderFns } from "./HubHealthSummary.vue?vue&type=template&id=239d4b56&scoped=true"
import script from "./HubHealthSummary.vue?vue&type=script&lang=js"
export * from "./HubHealthSummary.vue?vue&type=script&lang=js"
import style0 from "./HubHealthSummary.vue?vue&type=style&index=0&id=239d4b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d4b56",
  null
  
)

export default component.exports